/**
 * 🔴 O RÓTULO HUMANO DE UM CAMPO EXIGIDO POR FASE — um lugar só.
 *
 * ── Por que ele foi extraído (T1, 01/10/2026)
 *
 * O mapa existia **dentro** de `AbaFases.tsx`, e o `FunilPage` não o
 * enxergava: quando uma fase barrava o avanço, o toast dizia
 * *"Preencha antes de avançar: **origem_id**"*. 🔴 **Nome de coluna vazando
 * para quem usa a tela** — a régua desta casa é pt-BR sem jargão técnico.
 *
 * ⚠️ **Entrou como motor porque o T1 seria o TERCEIRO lugar** a montar a mesma
 * tradução. ✅ E os dois que já existiam **migraram no mesmo commit** — motor
 * que nasce sem consumidor vira órfão, e isso já aconteceu duas vezes aqui.
 *
 * 🔴 **A lista acompanha `CAMPOS_CARD_VALIDOS`** (`server/lib/crm/crm-engine.ts`).
 * ⚠️ Campo exigível sem rótulo aqui aparece como o nome da coluna — feio, mas
 * **honesto**: ❌ inventar um rótulo bonito para um campo que ninguém mapeou
 * esconderia a falta.
 */

const ROTULO: Record<string, string> = {
  cliente_id: 'Cliente do cadastro',
  servico_id: 'Serviço do catálogo',
  valor: 'Valor',
  responsavel_id: 'Responsável',
  observacoes: 'Observações',
  /** 🔴 T1: a origem é por REFERÊNCIA (`origem_id`), não pelo rótulo (#425). */
  origem_id: 'Origem',
};

/** O rótulo humano; na falta, o próprio nome do campo (honesto, não bonito). */
export function rotuloDoCampo(campo: string): string {
  return ROTULO[campo] ?? campo;
}

/** Os campos que têm rótulo — a lista que a configuração oferece. */
export function camposComRotulo(): Array<{ campo: string; rotulo: string }> {
  return Object.entries(ROTULO).map(([campo, rotulo]) => ({ campo, rotulo }));
}

/**
 * A frase de "faltou preencher", pronta para o toast ou para o balão do campo.
 *
 * ⚠️ **Ela diz o que FAZER, não só o que falta.** *"Preencha antes de avançar:
 * origem_id"* informa um erro; *"Escolha a origem..."* diz o próximo gesto —
 * e é a diferença entre a pessoa saber e a pessoa adivinhar.
 */
export function fraseDoQueFalta(campos: string[]): string {
  const nomes = campos.map(rotuloDoCampo);
  if (nomes.length === 0) return 'Faltam campos obrigatórios.';
  if (nomes.length === 1) return `Preencha ${nomes[0]} para continuar.`;
  const ultimo = nomes[nomes.length - 1];
  return `Preencha ${nomes.slice(0, -1).join(', ')} e ${ultimo} para continuar.`;
}
